import { render } from "./GroupBookingModal.vue?vue&type=template&id=3d512d4e&scoped=true"
import script from "./GroupBookingModal.vue?vue&type=script&lang=js"
export * from "./GroupBookingModal.vue?vue&type=script&lang=js"

import "./GroupBookingModal.vue?vue&type=style&index=0&id=3d512d4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d512d4e"]])

export default __exports__